import { useTranslation } from 'react-i18next'

import { getPropertyOwnerProfileOptions } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { Checkbox } from '../../../../Checkbox'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../../Formik'
import {
  SelectDropdownListFooter,
  SelectDropdownListHeader,
} from '../../../../Select'
import {
  toUserSelectItemsFromOption,
  USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  UserMultiSelect,
} from '../../../../User'
import {
  BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_ALL_FLATS,
  BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS,
} from '../BuildingsEditPropertyOwnersActionModal.constants'

function FormFields({ actionTypes }) {
  const { t } = useTranslation()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: {
        [BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS]: EMPTY_LIST,
      },
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          options: actionTypes,
        }}
      >
        <FormikField
          multi
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={UserMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t(
                  'Building.EditPropertyOwnersFieldPlaceholderKey'
                ),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          dropdownFloatingConfig={
            USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL
          }
          emptyValue={EMPTY_LIST}
          fieldComponentProps={{
            label: t('Building.EditPropertyOwnersFieldLabelKey'),
          }}
          getData={getPropertyOwnerProfileOptions}
          getDataItems={getItemsFromIdwellApiResponse}
          listProps={{
            Footer: SelectDropdownListFooter,
            Header: SelectDropdownListHeader,
          }}
          name={BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_PROPERTY_OWNERS}
          toPreparedItems={toUserSelectItemsFromOption}
        />
        <FormikField
          Component={Checkbox}
          getErrorProps={getFormikFormFieldErrorProps}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('Building.EditPropertyOwnersToAllFlatsFieldLabelKey')}
          name={BUILDING_EDIT_PROPERTY_OWNERS_FIELD_NAME_ALL_FLATS}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
